<template>
    <div>
        <div class="fixed inset-0 z-0 pointer-events-none overflow-hidden">
            <div class="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-primary/10 blur-[120px]"></div>
            <div
                class="absolute bottom-[-10%] right-[-10%] w-[30%] h-[30%] rounded-full bg-tertiary-container/5 blur-[100px]">
            </div>
        </div>
        <nav class="fixed top-0 w-full z-50 bg-background/60 backdrop-blur-2xl border-b border-white/5" id="top-nav">
            <div
                class="flex justify-between items-center px-margin-page py-6 max-w-container-max mx-auto md:px-margin-page px-6">

                <a class="font-headline-md text-headline-md font-bold text-on-surface scale-95 active:scale-90 transition-transform"
                    href="javascript:void(0)">
                    <div class="flex flex-col leading-none">
                        <span class="flex items-center gap-1">
                            <img src="/logo1.png" style="height: 2rem;">
                        </span>

                        <!-- New Small Tagline -->
                        <span class="text-[10px] uppercase tracking-[0.25em] text-on-surface-variant mt-2">
                            AI Products • SaaS • MVPs
                        </span>

                    </div>
                </a>

                <div class="hidden md:flex gap-8 items-center">

                    <a class="text-on-surface-variant font-label-sm text-label-sm uppercase tracking-[0.2em] hover:text-primary transition-colors duration-300"
                        href="#services">
                        Services
                    </a>

                    <a class="text-on-surface-variant font-label-sm text-label-sm uppercase tracking-[0.2em] hover:text-primary transition-colors duration-300"
                        href="#solutions">
                        Solutions
                    </a>

                    <a class="text-on-surface-variant font-label-sm text-label-sm uppercase tracking-[0.2em] hover:text-primary transition-colors duration-300"
                        href="#process">
                        Process
                    </a>

                    <a class="text-on-surface-variant font-label-sm text-label-sm uppercase tracking-[0.2em] hover:text-primary transition-colors duration-300"
                        href="#work">
                        Work
                    </a>

                    <a class="text-on-surface-variant font-label-sm text-label-sm uppercase tracking-[0.2em] hover:text-primary transition-colors duration-300"
                        href="#faq">
                        FAQ
                    </a>

                </div>

                <a class="hidden md:inline-flex items-center gap-2 bg-primary-container text-white font-label-sm text-label-sm uppercase tracking-widest px-8 py-3 rounded-full hover:shadow-[0_0_20px_rgba(255,107,0,0.4)] transition-all duration-300 relative overflow-hidden group"
                    href="#cta">

                    <span class="relative z-10" @click="gotowht()">
                        Book Discovery Call
                    </span>

                    <span
                        class="material-symbols-outlined text-[18px] relative z-10 group-hover:translate-x-1 transition-transform">
                        arrow_forward
                    </span>

                    <div
                        class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] pointer-events-none">
                    </div>

                </a>

                <button id="mobile-menu-btn" class="md:hidden text-on-surface p-2">
                    <span class="material-symbols-outlined" style="font-variation-settings: 'FILL' 0;">
                        menu
                    </span>
                </button>

            </div>
        </nav>
        <div id="mobile-menu"
            class="fixed top-[78px] left-0 w-full bg-background/95 backdrop-blur-xl border-t border-white/10 hidden z-40">

            <div class="flex flex-col p-6 gap-6">

                <a href="#services" class="mobile-link">Services</a>
                <a href="#solutions" class="mobile-link">Solutions</a>
                <a href="#process" class="mobile-link">Process</a>
                <a href="#work" class="mobile-link">Work</a>
                <a href="#faq" class="mobile-link">FAQ</a>

                <a href="javascript:void(0)" @click="gotowht()"
                    class="btn-primary text-center text-white py-4 rounded-full">
                    Book Discovery Call
                </a>

            </div>

        </div>
        <main class="relative z-10 pt-[120px]">
            <!-- 1. Hero Section -->
            <section
                class="min-h-[85vh] flex items-center justify-center px-margin-page md:px-margin-page px-6 relative py-stack-lg">

                <div class="max-w-container-max mx-auto w-full grid md:grid-cols-12 gap-gutter items-center">

                    <div class="md:col-span-8 flex flex-col items-start gap-stack-lg z-10 reveal-on-scroll is-visible">

                        <div class="glass-card px-4 py-2 rounded-full flex items-center gap-2 w-fit">
                            <span class="w-2 h-2 rounded-full bg-primary-container animate-pulse"></span>
                            <span class="font-label-sm text-label-sm text-on-surface-variant">
                                AI PRODUCTS • SAAS • MVP DEVELOPMENT
                            </span>
                        </div>

                        <h1 class="font-display-xl-mobile md:font-display-xl text-display-xl-mobile md:text-display-xl 
                text-on-surface max-w-[900px] tracking-tight">

                            Build AI Products, SaaS Platforms & MVPs
                            <br>
                            From Idea To Launch.

                        </h1>

                        <p class="font-body-lg text-body-lg text-on-surface-variant max-w-2xl">

                            Whether you're validating a startup idea, building an MVP, integrating AI into your
                            business,
                            or scaling an existing platform, I help transform ideas into reliable, production-ready
                            software
                            built for real users—not just demos.

                        </p>

                        <!-- Trust Points -->

                        <div class="flex flex-wrap gap-6 text-sm text-on-surface-variant">

                            <div class="flex items-center gap-2">
                                <span class="text-primary-container">✓</span>
                                Startup MVPs
                            </div>

                            <div class="flex items-center gap-2">
                                <span class="text-primary-container">✓</span>
                                AI Solutions
                            </div>

                            <div class="flex items-center gap-2">
                                <span class="text-primary-container">✓</span>
                                Custom SaaS
                            </div>

                            <div class="flex items-center gap-2">
                                <span class="text-primary-container">✓</span>
                                Long-Term Technical Partner
                            </div>

                        </div>

                        <div class="flex flex-col sm:flex-row gap-6 mt-4 w-full sm:w-auto">

                            <a class="btn-primary text-white font-label-sm text-label-sm uppercase tracking-widest px-8 py-4 rounded-DEFAULT flex items-center justify-center gap-2 hover:-translate-y-1 transition-transform"
                                href="javascript:void(0)" @click="gotowht()">

                                Book Discovery Call

                                <span class="material-symbols-outlined text-[18px]">
                                    arrow_forward
                                </span>

                            </a>

                            <a class="btn-ghost text-on-surface font-label-sm text-label-sm uppercase tracking-widest px-8 py-4 rounded-DEFAULT flex items-center justify-center hover:-translate-y-1 transition-transform"
                                href="#work">

                                View Recent Projects

                            </a>

                        </div>

                        <!-- <p class="text-sm text-on-surface-variant">

                        Have an idea but not sure where to start?
                        <strong class="text-on-surface">
                            Let's discuss it before you spend months building the wrong product.
                        </strong>

                    </p> -->
                        <div class="mt-0 flex flex-wrap gap-6 text-sm text-on-surface-variant">

                            <div class="flex items-center gap-2">
                                <span class="material-symbols-outlined text-primary-container text-lg">
                                    check_circle
                                </span>
                                Free 30-minute discovery call
                            </div>

                            <div class="flex items-center gap-2">
                                <span class="material-symbols-outlined text-primary-container text-lg">
                                    schedule
                                </span>
                                Usually replies within 24 hours
                            </div>

                        </div>
                    </div>

                    <div class="md:col-span-4 hidden md:block reveal-on-scroll is-visible"
                        style="transition-delay:200ms;">

                        <div class="relative w-full aspect-square rounded-xl overflow-hidden glass-card p-4 
                        transform rotate-3 hover:rotate-0 transition-all duration-700">

                            <div class="w-full h-full rounded-lg bg-surface-container-highest flex items-center justify-center 
                            relative overflow-hidden">
                                <img class="hero-image w-full h-full object-cover rounded-lg" src="/thedevswelly-hero.png">
                            </div>

                        </div>

                    </div>

                </div>

            </section>
            <!-- 2. Problems Section -->
            <section class="px-margin-page md:px-margin-page px-6 relative py-stack-lg" id="problems">

                <div class="max-w-container-max mx-auto reveal-on-scroll">

                    <h2 class="font-headline-lg text-headline-lg text-on-surface mb-stack-sm max-w-3xl tracking-tight">
                        Ideas Are Easy.<br>
                        <span class="text-on-surface-variant">Successful Products Aren't.</span>
                    </h2>

                    <p class="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mt-6">
                        Whether you're building an MVP, launching an AI product or scaling an existing platform,
                        these are the challenges most founders and businesses face before they reach out.
                    </p>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-gutter mt-16">

                        <!-- Card 1 -->

                        <div
                            class="glass-card rounded-xl p-8 hover:-translate-y-2 transition-transform flex flex-col gap-4 border-white/5 duration-700">

                            <div
                                class="w-12 h-12 rounded-full bg-surface-container-highest flex items-center justify-center border border-white/5">
                                <span class="material-symbols-outlined text-primary-container">
                                    rocket_launch
                                </span>
                            </div>

                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">
                                MVP Taking Too Long
                            </h3>

                            <p class="font-body-md text-body-md text-on-surface-variant">
                                Endless planning, changing requirements and slow development delay your launch while
                                competitors move faster.
                            </p>

                        </div>

                        <!-- Card 2 -->

                        <div
                            class="glass-card rounded-xl p-8 hover:-translate-y-2 transition-transform flex flex-col gap-4 border-white/5 duration-700">

                            <div
                                class="w-12 h-12 rounded-full bg-surface-container-highest flex items-center justify-center border border-white/5">
                                <span class="material-symbols-outlined text-primary-container">
                                    smart_toy
                                </span>
                            </div>

                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">
                                AI That Doesn't Deliver
                            </h3>

                            <p class="font-body-md text-body-md text-on-surface-variant">
                                AI demos look impressive, but production systems require reliability, scalability and
                                measurable business value.
                            </p>

                        </div>

                        <!-- Card 3 -->

                        <div
                            class="glass-card rounded-xl p-8 hover:-translate-y-2 transition-transform flex flex-col gap-4 border-white/5 duration-700">

                            <div
                                class="w-12 h-12 rounded-full bg-surface-container-highest flex items-center justify-center border border-white/5">
                                <span class="material-symbols-outlined text-primary-container">
                                    account_tree
                                </span>
                            </div>

                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">
                                Too Many Moving Parts
                            </h3>

                            <p class="font-body-md text-body-md text-on-surface-variant">
                                Managing freelancers, agencies and disconnected systems often leads to delays, technical
                                debt and expensive rebuilds.
                            </p>

                        </div>

                    </div>

                    <div class="mt-16 text-center">

                        <p class="text-on-surface-variant mb-6">
                            Sound familiar? Let's discuss your project before small problems become expensive mistakes.
                        </p>

                        <a class="btn-ghost inline-flex text-on-surface font-label-sm text-label-sm uppercase tracking-widest px-8 py-4 rounded-DEFAULT items-center justify-center hover:-translate-y-1 transition-transform"
                            href="#cta">

                            Discuss Your Project

                        </a>

                    </div>

                </div>

            </section>
            <!-- NEW SECTION: Who I Work With -->
            <section class="px-margin-page md:px-margin-page px-6 relative py-stack-lg" id="audience">

                <div class="max-w-container-max mx-auto reveal-on-scroll">

                    <h2 class="font-headline-lg text-headline-lg text-on-surface mb-stack-sm max-w-3xl tracking-tight">
                        Who I Help
                    </h2>

                    <p class="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mt-6">
                        Whether you're launching a startup, modernizing your business, or scaling an existing product,
                        I help build software that delivers real business outcomes.
                    </p>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-gutter mt-16">

                        <!-- Card 1 -->

                        <div class="glass-card rounded-xl p-8 flex flex-col gap-4 border-white/5">

                            <div class="text-primary-container font-bold text-sm tracking-widest">
                                01
                            </div>

                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">
                                Startup Founders
                            </h3>

                            <p class="font-body-md text-body-md text-on-surface-variant">
                                Turn your idea into a launch-ready MVP, validate faster, and build with a solid
                                technical
                                foundation.
                            </p>

                        </div>

                        <!-- Card 2 -->

                        <div class="glass-card rounded-xl p-8 flex flex-col gap-4 border-white/5">

                            <div class="text-primary-container font-bold text-sm tracking-widest">
                                02
                            </div>

                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">
                                Growing Businesses
                            </h3>

                            <p class="font-body-md text-body-md text-on-surface-variant">
                                Automate operations, integrate AI, and replace manual processes with scalable business
                                software.
                            </p>

                        </div>

                        <!-- Card 3 -->

                        <div class="glass-card rounded-xl p-8 flex flex-col gap-4 border-white/5">

                            <div class="text-primary-container font-bold text-sm tracking-widest">
                                03
                            </div>

                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">
                                Product Teams
                            </h3>

                            <p class="font-body-md text-body-md text-on-surface-variant">
                                Accelerate development, build AI features, and scale your product without growing your
                                engineering team.
                            </p>

                        </div>

                    </div>

                </div>

            </section>
            <!-- 3. Why Section -->
            <section class="px-margin-page md:px-margin-page px-6 relative py-stack-lg" id="why">
                <div class="max-w-container-max mx-auto reveal-on-scroll">
                    <h2 class="font-headline-lg text-headline-lg text-on-surface mb-stack-sm max-w-3xl tracking-tight">
                        Why Clients<br />
                        <span class="text-on-surface-variant">Choose To Work With Me</span>
                    </h2>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-gutter mt-16">
                        <div
                            class="glass-card rounded-xl p-8 hover:-translate-y-2 transition-transform flex flex-col gap-4 border-white/5 duration-700">
                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">Fast Product
                                Delivery
                            </h3>
                            <p class="font-body-md text-body-md text-on-surface-variant">
                                Launch MVPs and production software faster using proven architectures and AI-assisted
                                development.
                            </p>
                        </div>
                        <div
                            class="glass-card rounded-xl p-8 hover:-translate-y-2 transition-transform flex flex-col gap-4 border-white/5 duration-700">
                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">
                                Built To Scale
                            </h3>
                            <p class="font-body-md text-body-md text-on-surface-variant">
                                Every project is designed for long-term growth, making future expansion easier and more
                                cost-effective.
                            </p>
                        </div>
                        <div
                            class="glass-card rounded-xl p-8 hover:-translate-y-2 transition-transform flex flex-col gap-4 border-white/5 duration-700">
                            <h3 class="font-headline-md text-headline-md text-on-surface text-[24px]">
                                Business First
                            </h3>
                            <p class="font-body-md text-body-md text-on-surface-variant">
                                I focus on solving business problems and delivering measurable outcomes—not just writing
                                code.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 4. Services Section -->
            <section class="px-margin-page md:px-margin-page px-6 relative py-stack-lg" id="services">

                <div class="max-w-container-max mx-auto reveal-on-scroll">

                    <h2 class="font-headline-lg text-headline-lg text-on-surface mb-stack-sm max-w-3xl tracking-tight">
                        Solutions I Deliver
                    </h2>

                    <p class="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mt-6">
                        From startup MVPs to enterprise AI systems, I build reliable software that helps businesses
                        launch
                        faster,
                        automate operations and scale with confidence.
                    </p>

                    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-16">

                        <div
                            class="glass-card rounded-xl p-6 flex flex-col items-center justify-center text-center gap-2 border-white/5 hover:bg-white/5 transition-colors">
                            <span class="material-symbols-outlined text-primary-container text-3xl">smart_toy</span>
                            <span class="font-headline-md text-body-lg text-on-surface">
                                AI Products
                            </span>
                        </div>

                        <div
                            class="glass-card rounded-xl p-6 flex flex-col items-center justify-center text-center gap-2 border-white/5 hover:bg-white/5 transition-colors">
                            <span class="material-symbols-outlined text-primary-container text-3xl">cloud</span>
                            <span class="font-headline-md text-body-lg text-on-surface">
                                SaaS Platforms
                            </span>
                        </div>

                        <div
                            class="glass-card rounded-xl p-6 flex flex-col items-center justify-center text-center gap-2 border-white/5 hover:bg-white/5 transition-colors">
                            <span class="material-symbols-outlined text-primary-container text-3xl">rocket_launch</span>
                            <span class="font-headline-md text-body-lg text-on-surface">
                                MVP Development
                            </span>
                        </div>

                        <div
                            class="glass-card rounded-xl p-6 flex flex-col items-center justify-center text-center gap-2 border-white/5 hover:bg-white/5 transition-colors">
                            <span class="material-symbols-outlined text-primary-container text-3xl">support_agent</span>
                            <span class="font-headline-md text-body-lg text-on-surface">
                                AI Agents
                            </span>
                        </div>

                        <div
                            class="glass-card rounded-xl p-6 flex flex-col items-center justify-center text-center gap-2 border-white/5 hover:bg-white/5 transition-colors">
                            <span class="material-symbols-outlined text-primary-container text-3xl">description</span>
                            <span class="font-headline-md text-body-lg text-on-surface">
                                Document AI
                            </span>
                        </div>

                        <div
                            class="glass-card rounded-xl p-6 flex flex-col items-center justify-center text-center gap-2 border-white/5 hover:bg-white/5 transition-colors">
                            <span class="material-symbols-outlined text-primary-container text-3xl">account_tree</span>
                            <span class="font-headline-md text-body-lg text-on-surface">
                                Workflow Automation
                            </span>
                        </div>

                        <div
                            class="glass-card rounded-xl p-6 flex flex-col items-center justify-center text-center gap-2 border-white/5 hover:bg-white/5 transition-colors">
                            <span class="material-symbols-outlined text-primary-container text-3xl">settings</span>
                            <span class="font-headline-md text-body-lg text-on-surface">
                                CRM & ERP Systems
                            </span>
                        </div>

                        <div
                            class="glass-card rounded-xl p-6 flex flex-col items-center justify-center text-center gap-2 border-white/5 hover:bg-white/5 transition-colors">
                            <span class="material-symbols-outlined text-primary-container text-3xl">terminal</span>
                            <span class="font-headline-md text-body-lg text-on-surface">
                                Custom Software
                            </span>
                        </div>

                    </div>

                </div>

            </section> <!-- 5. Process Section -->
            <section class="px-margin-page md:px-margin-page px-6 relative py-stack-lg" id="process">

                <div class="max-w-container-max mx-auto reveal-on-scroll">

                    <h2 class="font-headline-lg text-headline-lg text-on-surface mb-stack-sm max-w-3xl tracking-tight">
                        From Idea<br />
                        <span class="text-on-surface-variant">To Production</span>
                    </h2>

                    <p class="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mt-6">
                        A simple, transparent process designed to move your project from concept to a reliable product
                        without unnecessary complexity.
                    </p>

                    <div class="flex flex-col md:flex-row justify-between items-start mt-16 gap-8 relative">

                        <div
                            class="absolute top-1/2 left-0 w-full h-0.5 bg-white/10 hidden md:block -z-10 -translate-y-1/2">
                        </div>

                        <div
                            class="glass-card p-4 rounded-xl flex-1 w-full text-center border-white/5 relative bg-background/80">
                            <div class="text-primary-container font-bold mb-2">01</div>
                            <div class="font-headline-md text-body-lg">Discover</div>
                        </div>

                        <div
                            class="glass-card p-4 rounded-xl flex-1 w-full text-center border-white/5 relative bg-background/80">
                            <div class="text-primary-container font-bold mb-2">02</div>
                            <div class="font-headline-md text-body-lg">Plan</div>
                        </div>

                        <div
                            class="glass-card p-4 rounded-xl flex-1 w-full text-center border-white/5 relative bg-background/80">
                            <div class="text-primary-container font-bold mb-2">03</div>
                            <div class="font-headline-md text-body-lg">Build</div>
                        </div>

                        <div
                            class="glass-card p-4 rounded-xl flex-1 w-full text-center border-white/5 relative bg-background/80">
                            <div class="text-primary-container font-bold mb-2">04</div>
                            <div class="font-headline-md text-body-lg">Launch</div>
                        </div>

                        <div
                            class="glass-card p-4 rounded-xl flex-1 w-full text-center border-white/5 relative bg-background/80">
                            <div class="text-primary-container font-bold mb-2">05</div>
                            <div class="font-headline-md text-body-lg">Optimize</div>
                        </div>

                        <div
                            class="glass-card p-4 rounded-xl flex-1 w-full text-center border-white/5 relative bg-background/80">
                            <div class="text-primary-container font-bold mb-2">06</div>
                            <div class="font-headline-md text-body-lg">Support</div>
                        </div>

                    </div>

                </div>

            </section>
            <!-- 6. Featured Work Section -->
            <section class="px-margin-page md:px-margin-page px-6 relative py-stack-lg" id="work">

                <div class="max-w-container-max mx-auto reveal-on-scroll">

                    <h2 class="font-headline-lg text-headline-lg text-on-surface mb-stack-sm max-w-3xl tracking-tight">
                        Selected<br />
                        <span class="text-on-surface-variant">Projects</span>
                    </h2>

                    <p class="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mt-6">
                        A selection of AI, SaaS and custom software projects built to solve real business problems.
                    </p>

                    <div class="flex flex-col gap-16 mt-16">

                        <!-- Project 1 -->

                        <div
                            class="glass-card rounded-2xl p-8 border-white/5 flex flex-col md:flex-row gap-8 items-center">

                            <div class="flex-1">

                                <h3 class="font-headline-md text-[32px] text-on-surface mb-4">
                                    AI Interview Platform
                                </h3>

                                <p class="font-body-md text-on-surface-variant mb-6">
                                    Built an AI-powered interview platform with voice conversations, candidate
                                    evaluation,
                                    automated reports and recruiter dashboards.
                                </p>

                                <div class="flex flex-wrap gap-2">

                                    <span
                                        class="px-3 py-1 bg-white/5 rounded-full text-xs text-on-surface-variant border border-white/10">
                                        AI
                                    </span>

                                    <span
                                        class="px-3 py-1 bg-white/5 rounded-full text-xs text-on-surface-variant border border-white/10">
                                        Voice AI
                                    </span>

                                    <span
                                        class="px-3 py-1 bg-white/5 rounded-full text-xs text-on-surface-variant border border-white/10">
                                        SaaS
                                    </span>

                                </div>

                            </div>

                            <div
                                class="flex-1 w-full aspect-video bg-surface-container-highest rounded-xl border border-white/10 flex items-center justify-center">
                                <img src="/ai-interview-project.png" style="width:100%; height:100%; object-fit:cover; border-radius:3rem; 
                                border:1px solid rgba(255,255,255,.08); box-shadow:0 20px 60px rgba(0,0,0,.35);">

                            </div>

                        </div>

                        <!-- Project 2 -->

                        <div
                            class="glass-card rounded-2xl p-8 border-white/5 flex flex-col md:flex-row-reverse gap-8 items-center">

                            <div class="flex-1">

                                <h3 class="font-headline-md text-[32px] text-on-surface mb-4">
                                    Document Intelligence Platform
                                </h3>

                                <p class="font-body-md text-on-surface-variant mb-6">
                                    Automated document processing using OCR, AI extraction and workflow automation to
                                    reduce
                                    manual work and improve accuracy.
                                </p>

                                <div class="flex flex-wrap gap-2">

                                    <span
                                        class="px-3 py-1 bg-white/5 rounded-full text-xs text-on-surface-variant border border-white/10">
                                        OCR
                                    </span>

                                    <span
                                        class="px-3 py-1 bg-white/5 rounded-full text-xs text-on-surface-variant border border-white/10">
                                        AI Automation
                                    </span>

                                    <span
                                        class="px-3 py-1 bg-white/5 rounded-full text-xs text-on-surface-variant border border-white/10">
                                        Workflow
                                    </span>

                                </div>

                            </div>

                            <div class="flex-1 w-full aspect-video bg-surface-container-highest rounded-xl border 
                            border-white/10 flex items-center justify-center">

                                <img src="/document-processiong-platform.png" style="width:100%; height:100%; 
                            object-fit:cover; border-radius:3rem; 
                                border:1px solid rgba(255,255,255,.08); box-shadow:0 20px 60px rgba(0,0,0,.35);">


                            </div>

                        </div>

                    </div>

                </div>

            </section>
            <!-- 7. FAQ Section -->
            <section class="px-margin-page md:px-margin-page px-6 relative py-stack-lg" id="faq">

                <div class="max-w-container-max mx-auto reveal-on-scroll">

                    <h2 class="font-headline-lg text-headline-lg text-on-surface mb-stack-sm max-w-3xl tracking-tight">
                        Frequently Asked<br />
                        <span class="text-on-surface-variant">Questions</span>
                    </h2>

                    <p class="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mt-6">
                        Everything you need to know before starting your AI, SaaS or MVP project.
                    </p>

                    <div class="mt-16 flex flex-col gap-4 max-w-3xl">

                        <!-- FAQ 1 -->

                        <details class="glass-card rounded-xl border-white/5 group">

                            <summary
                                class="font-headline-md text-body-lg p-6 cursor-pointer list-none flex justify-between items-center">

                                How do we get started?

                                <span class="material-symbols-outlined group-open:rotate-180 transition-transform">
                                    expand_more
                                </span>

                            </summary>

                            <div class="p-6 pt-0 font-body-md text-on-surface-variant border-t border-white/5 mt-2">

                                We begin with a discovery call to understand your goals, challenges and project
                                requirements. After that, you'll receive a clear roadmap, timeline and next steps.

                            </div>

                        </details>

                        <!-- FAQ 2 -->

                        <details class="glass-card rounded-xl border-white/5 group">

                            <summary
                                class="font-headline-md text-body-lg p-6 cursor-pointer list-none flex justify-between items-center">

                                Can you build an MVP first and scale later?

                                <span class="material-symbols-outlined group-open:rotate-180 transition-transform">
                                    expand_more
                                </span>

                            </summary>

                            <div class="p-6 pt-0 font-body-md text-on-surface-variant border-t border-white/5 mt-2">

                                Yes. Most projects start with a lean MVP focused on validating the idea quickly, while
                                keeping the architecture ready for future growth.

                            </div>

                        </details>

                        <!-- FAQ 3 -->

                        <details class="glass-card rounded-xl border-white/5 group">

                            <summary
                                class="font-headline-md text-body-lg p-6 cursor-pointer list-none flex justify-between items-center">

                                Can you work with our existing team?

                                <span class="material-symbols-outlined group-open:rotate-180 transition-transform">
                                    expand_more
                                </span>

                            </summary>

                            <div class="p-6 pt-0 font-body-md text-on-surface-variant border-t border-white/5 mt-2">

                                Absolutely. I can work independently or collaborate with your developers, designers and
                                product team throughout the project.

                            </div>

                        </details>

                        <!-- FAQ 4 -->

                        <details class="glass-card rounded-xl border-white/5 group">

                            <summary
                                class="font-headline-md text-body-lg p-6 cursor-pointer list-none flex justify-between items-center">

                                Who owns the source code and intellectual property?

                                <span class="material-symbols-outlined group-open:rotate-180 transition-transform">
                                    expand_more
                                </span>

                            </summary>

                            <div class="p-6 pt-0 font-body-md text-on-surface-variant border-t border-white/5 mt-2">

                                You own everything. Once the project is completed and delivered, all source code and
                                intellectual property belong to you.

                            </div>

                        </details>

                        <!-- FAQ 5 -->

                        <details class="glass-card rounded-xl border-white/5 group">

                            <summary
                                class="font-headline-md text-body-lg p-6 cursor-pointer list-none flex justify-between items-center">

                                Do you provide support after launch?

                                <span class="material-symbols-outlined group-open:rotate-180 transition-transform">
                                    expand_more
                                </span>

                            </summary>

                            <div class="p-6 pt-0 font-body-md text-on-surface-variant border-t border-white/5 mt-2">

                                Yes. I can continue improving the product, add new features, optimize performance and
                                provide long-term technical support as your business grows.

                            </div>

                        </details>

                        <details class="glass-card rounded-xl border-white/5 group">

                            <summary
                                class="font-headline-md text-body-lg p-6 cursor-pointer list-none flex justify-between items-center">

                                How much does a project cost?

                                <span class="material-symbols-outlined group-open:rotate-180 transition-transform">

                                    expand_more

                                </span>

                            </summary>

                            <div class="p-6 pt-0 font-body-md text-on-surface-variant border-t border-white/5 mt-2">

                                Every project is different. After understanding your goals and requirements, you'll
                                receive a clear proposal with timeline, milestones and fixed pricing.

                            </div>

                        </details>

                    </div>

                </div>

            </section>
            <!-- 8. Final CTA Section -->
            <section class="px-margin-page md:px-margin-page px-6 relative py-section-gap" id="cta">

                <div class="max-w-container-max mx-auto text-center reveal-on-scroll">

                    <h2
                        class="font-display-xl-mobile md:font-display-xl text-display-xl-mobile md:text-display-xl text-on-surface mb-8 tracking-tight">

                        Let's Build Something
                        <br>
                        Your Customers Will Love.

                    </h2>

                    <p class="font-body-lg text-on-surface-variant mb-12 max-w-2xl mx-auto">

                        Whether you're launching an MVP, building an AI product or modernizing your business,
                        let's discuss your goals and find the right technical approach—before you invest months building
                        the
                        wrong solution.

                    </p>

                    <div class="flex flex-col sm:flex-row justify-center items-center gap-5">

                        <a class="btn-primary inline-flex text-white font-label-sm text-label-sm uppercase tracking-widest px-10 py-5 rounded-full items-center justify-center gap-2 hover:-translate-y-1 transition-transform text-lg"
                            href="javascript:void(0)" @click="gotowht()">

                            Book Discovery Call

                            <span class="material-symbols-outlined">
                                arrow_forward
                            </span>

                        </a>

                        <a class="btn-ghost inline-flex font-label-sm text-label-sm uppercase tracking-widest px-10 py-5 rounded-full items-center justify-center gap-2 hover:-translate-y-1 transition-transform"
                            href="javascript:void(0)" @click="gotowht1()">

                            Chat on WhatsApp

                        </a>

                    </div>

                    <p class="text-sm text-on-surface-variant mt-8">

                        No sales pitch. Just a practical conversation about your project, timeline and next steps.

                    </p>

                </div>

            </section>
        </main>
        <footer class="footer-premium">

            <div class="footer-brand" style="display:flex; flex-direction:column; align-items:center;">
                <img src="/logo1.png" style="height: 2rem;">
                <p>
                    Building AI Products, SaaS Platforms & MVPs for Startups & Businesses.
                </p>
            </div>

            <div class="footer-bottom">

                <span>
                    © 2026 Thedevswelly. All rights reserved.
                </span>

                <div class="footer-links">
                    <a href="https://www.linkedin.com/in/bhupesh-p-581145111/" target="_blank">LinkedIn</a>
                    <a href="https://github.com/thedevswelly" target="_blank">GitHub</a>
                    <a href="javascript:void(0)" @click="gotowht1()" target="_blank">WhatsApp</a>
                </div>

            </div>

        </footer>
        <!-- Floating WhatsApp Button -->
        <a href="javascript:void(0)" @click="gotowht1()" class="floating-whatsapp">

            <div class="wa-pulse"></div>

            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="white">

                <path
                    d="M20.52 3.48A11.81 11.81 0 0 0 12.04 0C5.51 0 .19 5.32.19 11.85c0 2.09.54 4.13 1.57 5.93L0 24l6.39-1.67a11.8 11.8 0 0 0 5.65 1.44h.01c6.53 0 11.84-5.31 11.84-11.84A11.8 11.8 0 0 0 20.52 3.48zm-8.48 18.3h-.01a9.86 9.86 0 0 1-5.03-1.38l-.36-.21-3.79.99 1.01-3.69-.23-.38a9.82 9.82 0 1 1 8.41 4.67zm5.4-7.37c-.3-.15-1.79-.88-2.07-.98-.28-.1-.48-.15-.69.15-.2.3-.79.98-.97 1.18-.18.2-.35.23-.65.08-.3-.15-1.27-.47-2.42-1.49-.89-.79-1.5-1.77-1.67-2.07-.18-.3-.02-.46.13-.61.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.69-1.67-.95-2.29-.25-.59-.51-.51-.69-.52h-.59c-.2 0-.53.08-.81.38-.28.3-1.07 1.04-1.07 2.54 0 1.5 1.09 2.95 1.24 3.16.15.2 2.14 3.27 5.18 4.58.72.31 1.28.49 1.72.63.72.23 1.37.2 1.89.12.58-.09 1.79-.73 2.04-1.43.25-.71.25-1.31.18-1.43-.08-.12-.28-.2-.58-.35z" />
            </svg>

        </a>
    </div>
</template>


<script>

    export default {
        name: "App",
        methods: {
            gotowht() {
                window.open('https://calendly.com/bpatidar2793/15-minute-meeting', '_blank');
            },
            gotowht1() {
                const phone = "918962364900";
                //const message = "Hi Bhupesh, I saw your website. I want help with MVP/system clarity.";
                const message = "Hi Bhupesh, I saw your site. I’m building a product and want clarity on where it may break in production."
                const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
                window.open(url, "_blank");
            }
        },
        mounted() {
            document.addEventListener('DOMContentLoaded', () => {
                const observerOptions = {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.1
                };

                const observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('is-visible');
                            observer.unobserve(entry.target);
                        }
                    });
                }, observerOptions);

                document.querySelectorAll('.reveal-on-scroll').forEach(el => {
                    observer.observe(el);
                });
            });

            const menuBtn = document.getElementById("mobile-menu-btn");
            const mobileMenu = document.getElementById("mobile-menu");

            menuBtn.addEventListener("click", () => {
                mobileMenu.classList.toggle("hidden");
            });

            document.querySelectorAll(".mobile-link").forEach(link => {
                link.addEventListener("click", () => {
                    mobileMenu.classList.add("hidden");
                });
            });
        }
    };
</script>
<style scoped>
    /* =========================================================
   FLOATING CHAT BUTTON (BOTTOM RIGHT)
========================================================= */

    #chat-fab {
        position: fixed;
        bottom: 24px;
        right: 24px;
        width: 4.5rem;
        height: 4.5rem;
        border-radius: 50%;
        background: linear-gradient(135deg,
                #e19831,
                #e19831);
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.5rem;
        text-decoration: none;
        box-shadow: 0 18px 40px rgba(2, 6, 23, 0.45);
        z-index: 9999;
        transition: transform 0.25s ease, box-shadow 0.25s ease;
    }

    #chat-fab:hover {
        transform: translateY(-4px);
        box-shadow: 0 0px 26px rgba(225, 152, 49, 0.4);
    }

    @media (max-width: 480px) {
        #chat-fab {
            width: 3.6rem;
            height: 3.6rem;
            font-size: 2rem;
            bottom: 16px;
            right: 16px;
        }
    }

    @media (max-width: 768px) {
        .hide-mobile {
            display: none !important;
        }
    }

    /* ===============================
   HERO PROBLEM LIST
=============================== */

    .hero-problems {
        margin-top: 18px;
    }

    .hero-problems p {
        font-weight: 600;
        margin-bottom: 6px;
    }

    .hero-problems ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .hero-problems li {
        position: relative;
        padding-left: 22px;
        margin-bottom: 6px;
        font-size: 0.95rem;
        color: #cbd5e1;
    }

    .hero-problems li::before {
        content: "•";
        position: absolute;
        left: 0;
        top: 0;
        color: #e19831;
        font-size: 1.2rem;
    }

    /* ===============================
   SECONDARY CTA BUTTON
=============================== */

    .btn.ghost {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.35);
        color: #ffffff;
    }

    .btn.ghost:hover {
        background: rgba(255, 255, 255, 0.06);
        border-color: #ffffff;
    }

    /* ===============================
   CENTER UTIL
=============================== */

    .center {
        text-align: center;
    }

    /* ===============================
   PRICE CARD CTA
=============================== */

    .price-card .btn {
        margin-top: 18px;
    }

    /* ===============================
   FINAL CTA SECTION TEXT
=============================== */

    .cta h2 {
        font-size: 2.2rem;
        font-weight: 600;
    }

    .cta p {
        max-width: 520px;
        margin: 12px auto 24px;
        color: #cbd5e1;
    }

    /* ===============================
   SMALL RESPONSIVE TWEAK
=============================== */

    @media (max-width: 768px) {
        .hero-problems li {
            font-size: 0.9rem;
        }
    }

    /* ===============================
   RECENT WORK – OUTCOME LIST
=============================== */

    .recent-work .work-list {
        max-width: 720px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 28px;
    }

    .work-row {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        position: relative;
    }

    .work-dot {
        width: 10px;
        height: 10px;
        background: #e19831;
        border-radius: 50%;
        margin-top: 10px;
        flex-shrink: 0;
    }

    .work-content h3 {
        margin: 0 0 6px;
        font-size: 1.05rem;
        font-weight: 600;
    }

    .work-content p {
        margin: 0;
        color: #cbd5e1;
        font-size: 0.95rem;
        line-height: 1.6;
    }

    /* ===============================
   RECENT WORK – MOTION
=============================== */

    .work-row {
        opacity: 0;
        transform: translateY(18px);
        animation: workFadeUp 0.7s ease forwards;
    }

    /* Staggered delay */
    .work-row:nth-child(1) {
        animation-delay: 0.05s;
    }

    .work-row:nth-child(2) {
        animation-delay: 0.15s;
    }

    .work-row:nth-child(3) {
        animation-delay: 0.25s;
    }

    .work-row:nth-child(4) {
        animation-delay: 0.35s;
    }

    @keyframes workFadeUp {
        from {
            opacity: 0;
            transform: translateY(18px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Small dot pulse */
    .work-dot {
        animation: dotPulse 2.5s ease-in-out infinite;
    }

    @keyframes dotPulse {
        0% {
            transform: scale(1);
            opacity: 0.7;
        }

        50% {
            transform: scale(1.4);
            opacity: 1;
        }

        100% {
            transform: scale(1);
            opacity: 0.7;
        }
    }

    /* ===============================
   PRICE CARD ALIGNMENT FIX
=============================== */
    .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .price-card {
        display: flex;
        flex-direction: column;
    }

    .price-card ul {
        flex-grow: 1;
    }

    .price-card .btn {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }

    /* Floating WhatsApp */

    .floating-whatsapp {

        position: fixed;

        right: 28px;

        bottom: 28px;

        width: 64px;

        height: 64px;

        border-radius: 50%;

        background: #E19831;

        display: flex;

        align-items: center;

        justify-content: center;


        z-index: 9999;

        transition: .35s;

        text-decoration: none;

        overflow: hidden;

    }

    .floating-whatsapp:hover {

        transform: translateY(-6px) scale(1.08);
 box-shadow:0 25px 60px rgba(225,152,49,.55);
    }
    

    .wa-pulse {

        position: absolute;

        width: 100%;

        height: 100%;

        border-radius: 50%;

        background: #E19831;

        opacity: .35;

        animation: waPulse 2s infinite;

    }

    .floating-whatsapp svg {

        position: relative;

        z-index: 2;

    }

    @keyframes waPulse {

        0% {

            transform: scale(1);

            opacity: .45;

        }

        70% {

            transform: scale(1.6);

            opacity: 0;

        }

        100% {

            transform: scale(1.6);

            opacity: 0;

        }

    }

    @media(max-width:768px) {

        .floating-whatsapp {

            right: 18px;

            bottom: 18px;

            width: 58px;

            height: 58px;

        }

    }
    .hero-image{

animation:heroFloat 6s ease-in-out infinite;

}

@keyframes heroFloat{

0%,100%{

transform:translateY(0px);

}

50%{

transform:translateY(-10px);

}

}
</style>